import { useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useUser from "hooks/useUser";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { news: { GET_OUTLETS } } = queries;
const { news: { ADD_OUTLET } } = mutations;
const usePrepareComponent = () => {
    const history = useHistory();
    const { isAdmin, isEditor } = useUser();
    const [addOutlet, { loading: isSaveLoading }] = useMutation(ADD_OUTLET, { refetchQueries: [GET_OUTLETS] });
    const onCancel = () => {
        history.push("/news/outlets");
    };
    const onSave = (input) => {
        if (!input.domain || !input.name || !input.slug || !input.url) {
            return;
        }
        const outletAddInput = {
            bio: input.bio,
            domain: input.domain,
            isPublished: false,
            logoImageId: input.logoImageId ? Number(input.logoImageId) : undefined,
            name: input.name,
            slug: input.slug,
            splashImageId: input.splashImageId
                ? Number(input.splashImageId)
                : undefined,
            url: input.url
        };
        addOutlet({
            onCompleted: ({ addOutlet: { id } }) => {
                history.push(`/news/outlets/${id}`);
            },
            variables: { outletAddInput }
        });
    };
    return {
        isAdmin,
        isEditor,
        isSaveLoading,
        onCancel,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Add);
